import React, { useState, useEffect, useRef } from "react";
import { FaPlus, FaTrashAlt, FaThLarge, FaBars, FaSearch, FaPlayCircle, FaTrash } from "react-icons/fa";
import { MdTour } from "react-icons/md";
import "./Tvplayouts.css";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Whisper, Tooltip } from 'rsuite';
// import 'rsuite/Tooltip/styles/index.css';


import FormContainer from "../../components/CommonComponents/FormContainer";
import AdminCustomButton from "../../components/CommonComponents/AdminCustomButton";
import MessageHeading from "../../components/CommonComponents/MessageHeading";
import { useMyContext } from '../../components/Provider/CommonProvider'
import AdminSaveHeader from "../../components/CommonComponents/AdminSaveHeader";
import Wrapper from "../../components/CommonComponents/Wrapper";
import AdminCustomSelect from "../../components/CommonComponents/AdminCustomSelect";
import LeftWrapper from "../../components/CommonComponents/LeftWrapper";
import RightWrapper from "../../components/CommonComponents/RightWrapper";
import MessageSubHeading from "../../components/CommonComponents/MessageSubHeading";
import MessageLabel from "../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../components/CommonComponents/AdminCustomInput";
import Defaultloadinggif from "../../layout/Others/Defaultloadinggif";
import AdminDeleteModal from "../../components/CommonComponents/AdminDeleteModal";
import Response_Processing from "../../layout/Others/Response_Processing";
import { usePlayoutTour } from "../../components/Tour/PlayoutTourProvider";


function Tvplayouts() {

    const labelSource = 'tv-playout-index'
    const baseURL = process.env.REACT_APP_Baseurl

    // api's call
    const indexApi = `${baseURL}/admin/playout`
    const statusApi = `${baseURL}/admin/playout/status`
    const deleteApi = `${baseURL}/admin/playout/delete`
    const reorderApi = `${baseURL}/admin/playout/reorder`
    // const labelSource = 'tv-playout-crate'
    const storeApi = `${baseURL}/admin/playout/store`
    const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`


    // hook's
    const [formData, setFormData] = useState({ filterValue: '' })
    const [createData, setCreateData] = useState({
        name: '',
        playout_types: ''
    })
    const [actionItem, setActionItem] = useState({})
    const [labelDisplay, setLabelDisplay] = useState([])
    const [viewMode, setViewMode] = useState("grid")
    const [modalOpen, setModalOpen] = useState(false)
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true)
    const { fetchRequest, deleteImageFile } = useMyContext()
    const [formDataError, setformDataError] = useState({})
    const combinedRef = useRef({ title: null, playout_mode: null });
    const [modalClose, setModalClose] = useState(false)
    const [showOverlay, setShowOverlay] = useState(false)
    const dragItem = useRef(null)
    const dragOverItem = useRef(null)

    const handleDragStart = (index) => {
        dragItem.current = index;
    }

    const handleDragEnter = (index) => {
        dragOverItem.current = index;
    }

    const handleDragEnd = async () => {
        const sorted = getSortedData();
        const from = dragItem.current;
        const to = dragOverItem.current;

        if (from === null || to === null || from === to) {
            dragItem.current = null;
            dragOverItem.current = null;
            return;
        }

        const reordered = [...sorted];
        const [moved] = reordered.splice(from, 1);
        reordered.splice(to, 0, moved);

        const items = reordered.map((item, idx) => ({ id: item.id, order: idx + 1 }));

        setFormData(prev => ({ ...prev, value: reordered }));
        dragItem.current = null;
        dragOverItem.current = null;

        try {
            await fetchRequest({ method: 'POST', url: reorderApi, data: { items } });
        } catch (error) {
            toast.error('Failed to save new order');
        }
    }

    const scheduleTypes = [{ name: 'Schedule', value: 'schedule' }, { name: 'Loop', value: 'loop' }]

    const handleInput = (e) => {
        const { name, value, type } = e.target

        if (type === 'text') {
            setCreateData((prev) => ({
                ...prev,
                [name]: value
            }))
            setformDataError((prev) => ({
                ...prev,
                [name]: ''
            }))
        } else if (type === 'select-one') {
            setCreateData((prev) => ({
                ...prev,
                [name]: value
            }))
            setformDataError((prev) => ({
                ...prev,
                [name]: ''
            }))
        }
    }

    const formValidation = () => {
        let formIsvalid = true;

        if (!createData?.name) {
            setformDataError((prev) => ({
                ...prev,
                name: "Name Can't be Empty"
            }))
            combinedRef.current['name'].focus();
            formIsvalid = false
        }
        if (!createData?.playout_types) {
            setformDataError((prev) => ({
                ...prev,
                playout_types: "Schedule type Can't be Empty"
            }))
            combinedRef.current['playout_types'].focus();
            formIsvalid = false
        }
        return formIsvalid;
    }

    const handleSubmit = async () => {
        const formValid = formValidation();

        if (formValid) {
            setShowOverlay(true)
            const record = {
                name: createData?.name,
                playout_types: createData?.playout_types
            }
            try {
                const response = await fetchRequest({
                    method: 'POST',
                    url: `${storeApi}`,
                    data: record
                })
                if (response?.status) {
                    setModalOpen(false)
                    toast.success(response?.message)
                    setFormData(prev => ({
                        ...prev,
                        value: [...(prev.value || []), response?.data]
                    }))
                    setCreateData(prev => ({
                        ...prev,
                        name: ''
                    }))
                    setCreateData(prev => ({
                        ...prev,
                        playout_types: ''
                    }))
                    setShowOverlay(false)
                    window.location.href = `/edit/tv-playouts/${response?.data?.id}`
                }
            } catch (error) {
                toast.error(error?.response?.message)
            }
        }
    }

    const handleModalOpen = async (value) => {
        setModalOpen(value)
        if (!value) {
            setCreateData(prev => ({
                ...prev,
                name: ''
            }))
            setCreateData(prev => ({
                ...prev,
                playout_types: ''
            }))
        }
    }

    const handleSelect = (e) => {
        const { type, value } = e.target

        if (type === 'select-one') {
            setFormData(prev => {
                return {
                    ...prev,
                    filterValue: value
                }
            })
        }
    }

    const handleViewToggle = (mode) => {
        setViewMode(mode);
    };

    const getSortedData = () => {
        if (!formData?.value) return [];

        let sorted = [...formData.value];

        if (searchTerm) {
            sorted = sorted.filter(item =>
                item.name.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        switch (formData.filterValue) {
            case 'Sort By Oldest':
                sorted.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
                break;
            case 'Sort By Newest':
                sorted.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                break;
            case 'A to Z':
                sorted.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
                break;
            case 'Z to A':
                sorted.sort((a, b) => (b.name || "").localeCompare(a.name || ""));
                break;
            default:
                break; // no sort
        }

        return sorted;
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const date = new Date(dateString);

        const day = date.getDate();

        const suffix = (day) => {
            if (day > 3 && day < 21) return 'th';
            switch (day % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        };
        return `${date.toLocaleString('default', { month: 'long' })} ${day}${suffix(day)}, ${date.getFullYear()}`;
    }

    const getStreamStatusClassName = (status) => {
        switch (Number(status)) {
            case 1:
                return 'stream-status-live';
            case 2:
                return 'stream-status-scheduled';
            default:
                return 'stream-status-offline';
        }
    }

    const getStreamStatusLabel = (status) => {
        switch (Number(status)) {
            case 1:
                return 'Live';
            case 2:
                return 'Scheduled';
            default:
                return 'Offline';
        }
    }

    const renderStatusBadge = (status) => (
        <span className={`playout-stream-status ${getStreamStatusClassName(status)}`}>
            <span className="playout-stream-status-dot"></span>
            {getStreamStatusLabel(status)}
        </span>
    )

    const renderTitleWithStatus = (item, isListView = false) => (
        <div className={`playout-title-row ${isListView ? 'playout-title-row-list' : ''}`}>
            <div className="playout-title-text">
                <MessageHeading
                    text={item?.name}
                    noMargin
                    customPadding={`pb-0`}
                    border={isListView}
                />
            </div>
            {renderStatusBadge(item?.streaming_status)}
        </div>
    )

    const renderStreamSummary = (item) => (
        <div className="playout-stream-summary">
            <div className="playout-stream-row">
                <span className="playout-stream-label">RTMP</span>
                <span
                    className="playout-stream-value"
                    title={item?.selected_rtmp_name || 'No RTMP selected'}
                >
                    {item?.selected_rtmp_name || 'No RTMP selected'}
                </span>
            </div>
            <div className="playout-stream-row">
                <span className="playout-stream-label">HLS</span>
                <span
                    className="playout-stream-value"
                    title={item?.current_hls_url || 'No HLS URL available'}
                >
                    {item?.current_hls_url || 'No HLS URL available'}
                </span>
            </div>
        </div>
    )

    const labelFetch = async () => {
        try {
            const response = await fetchRequest({
                method: 'GET',
                url: `${labelApi}`,
                date: {}
            })
            if (response?.status) {
                console.log(`label data: ${JSON.stringify(response?.label_management)}`);
                setLabelDisplay(response?.label_management)
            }
        } catch (error) {
            console.error(error.response?.data?.message);
        }
    }

    const fetchData = async () => {
        setLoading(true)
        try {
            const result = await fetchRequest({
                method: 'GET',
                url: `${indexApi}`,
                data: {}
            })
            if (result?.status) {
                setFormData(result)
                setLoading(false)
            }
        } catch (error) {
            toast.error(error?.result?.message)
        }
    }

    const closeModal = () => {
        setModalClose(!closeModal)
        setActionItem({})
    }

    const handleStatusToggle = async (index, item, status) => {
        setActionItem(prev => ({
            ...prev,
            action: 'disable',
            index,
            id: item,
            status
        }))
        setModalClose(!modalClose);
    }

    const handleDelete = (index, item) => {
        setModalClose(!modalClose);
        setActionItem(prev => ({
            ...prev,
            action: 'delete',
            index,
            id: item
        }))
    }

    const handleDeleteImage = async () => {
        await deleteImageFile(actionItem?.id, "AdminPlayout");
    }


    const handleAction = async () => {
        setShowOverlay(true)

        const itemId = actionItem?.id;
        const itemIndex = actionItem?.index;
        const itemStatus = actionItem?.status === 1 ? 0 : 1
        await handleDeleteImage();

        if (actionItem?.action === 'delete') {

            try {
                const result = await fetchRequest({
                    method: 'DELETE',
                    url: `${deleteApi}/${itemId}`,
                    data: {}
                })

                if (result?.status) {
                    toast.success(result?.message)
                    setFormData(prev => {
                        const record = [...prev?.value]
                        record.splice(itemIndex, 1)
                        return {
                            ...prev,
                            value: record
                        }
                    })
                    setActionItem({})
                    closeModal()
                    setShowOverlay(false)
                }
            } catch (error) {
                toast.error(error?.result?.message)
            }
        } else {
            const updateData = {
                id: itemId,
                status: itemStatus,
            }
            try {
                const response = await fetchRequest({
                    method: 'POST',
                    url: `${statusApi}`,
                    data: updateData
                })

                console.log(`store response.. ${JSON.stringify(response)}`);
                if (response?.status) {
                    setActionItem({})
                    closeModal()
                    setShowOverlay(false)
                    setFormData(prev => {
                        const updatedValue = [...prev?.value];
                        const newStatus = response?.data?.status
                        updatedValue[itemIndex] = {
                            ...updatedValue[itemIndex],
                            status: newStatus
                        }
                        return {
                            ...prev,
                            value: updatedValue
                        }
                    })
                }
            } catch (error) {
                toast.error(error.response?.message)
            }

        }
    }

    useEffect(() => {
        labelFetch()
    }, [])

    useEffect(() => {
        fetchData()
    }, [])

    // Get tour controls
    const { startPlayoutTour, isPlayoutTourRunning } = usePlayoutTour();

    if (loading) {
        return <Defaultloadinggif className={"heightOnLoader"} />
    }

    return (
        <>
            {showOverlay && (<Response_Processing />)}
            <div className="d-flex align-items-center flex-wrap px-md-0 px-3 mb-3 pb-3">
                <div className="col-sm-6 col-12">
                    <MessageHeading text={labelDisplay?.[0]?.title} className="admin-title pb-sm-0 text-md-start" noMargin />
                </div>
                <div className="col-sm-6 col-12 d-flex align-items-center justify-content-end mt-md-0 mt-3 gap-3">
                    <button
                        type="button"
                        className="playout-tour-trigger"
                        onClick={startPlayoutTour}
                    >
                        <MdTour className="tour-icon" />
                        <span>Playout Guide</span>
                    </button>
                    <AdminCustomButton
                        id="playout-create-btn"
                        saveMethod={() => handleModalOpen(true)}
                        saveText={labelDisplay?.[1]?.title}
                    />
                </div>
            </div>
            {modalClose && <AdminDeleteModal modelClose={modalClose} deleteClose={closeModal} buttonBg={actionItem?.action === 'delete' ? `success` : actionItem?.status === 0 ? `danger` : `success`} headingText={`${actionItem?.action === 'delete' ? 'Confirm Deletion' : `${actionItem?.status === 1 ? 'Confirm Disable' : 'Confirm Enable'}`}`} deleteAction={handleAction} actionText={actionItem?.action === 'delete' ? `Delete` : `${actionItem?.status === 1 ? 'Disable' : 'Enable'}`} buttonText={'custom'} message={`${actionItem?.action === 'delete' ? `Are you sure you want to delete?` : `Are you sure want to ${actionItem?.status === 1 ? `Disable` : `Enable`}`}`} />}
            {modalOpen && <div className="offcanvas offcanvas-end show" tabindex="-1" id="offcanvasPayout" aria-labelledby="offcanvasPayoutLabel">
                <Wrapper>
                    <FormContainer className={`justify-content-between`}>
                        <AdminSaveHeader className={`col-10`} heading={labelDisplay?.[0]?.title} hideButton />
                        <button onClick={() => handleModalOpen(false)} type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                    </FormContainer>
                    <MessageHeading text={labelDisplay?.[1]?.title} />
                    <MessageLabel text={labelDisplay?.[2]?.title} className="mandatorySimple" />
                    <MessageSubHeading text={labelDisplay?.[2]?.sub_title} />
                    <AdminCustomInput id="create-name" type="text" name="name" value={createData?.name} onChange={handleInput} placeHolder={"Title"} maxLength={50} ref={(el) => (combinedRef.current.name = el)} error={formDataError?.name}></AdminCustomInput>
                    <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
                    <MessageSubHeading text={labelDisplay?.[3]?.sub_title} />
                    <AdminCustomSelect id="create-select-type" name="playout_types" value={createData?.playout_types} options={scheduleTypes?.map((item) => ({ name: item.name, value: item.value }))} onChange={handleInput} ref={(el) => (combinedRef.current.playout_types = el)} error={formDataError?.playout_types} defaultOptionName={"Select type"}></AdminCustomSelect>
                    <AdminCustomButton className='px-3 py-1 me-3 me-md-0 ms-md-auto d-flex w-100 justify-content-center' saveMethod={handleSubmit} saveText={labelDisplay?.[4]?.title} />
                </Wrapper>
            </div>}

            <Wrapper>
                <FormContainer>
                    <LeftWrapper>
                        <FormContainer className={`justify-content-between`}>
                            <AdminCustomSelect noMargin id="playout-filter" customWidth={`w-45`} name="filterValue" value={formData?.filterValue} options={formData?.filter_type} onChange={handleSelect} />
                            <div className="search-container w-45">
                                <FaSearch className="search-icon" />
                                <input type='search' id="playout-search-input" placeholder='Search' name="title" className='table-search search-input' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                            </div>
                        </FormContainer>
                    </LeftWrapper>
                    <RightWrapper className={`text-end`}>
                        <Whisper placement="top" speaker={<Tooltip>Grid View</Tooltip>}>
                            <button id="grid-view" className="btn btn-outline-secondary mx-2" onClick={() => handleViewToggle("grid")}>
                                <FaThLarge />
                            </button>
                        </Whisper>
                        <Whisper placement="top" speaker={<Tooltip>List View</Tooltip>}>
                            <button id="list-view" className="btn btn-outline-secondary" onClick={() => handleViewToggle("list")}>
                                <FaBars />
                            </button>
                        </Whisper>
                    </RightWrapper>
                </FormContainer>
            </Wrapper>
            {!formData?.value?.length > 0 ? (
                <Wrapper className={`text-center`}>
                    <MessageHeading text={`No Data Available!`} />
                </Wrapper>
            ) :
                (
                    <Wrapper>
                        {
                            viewMode === 'grid' ? (
                                <FormContainer>
                                    {getSortedData().map((item, index) => (
                                        <div
                                            className="individual_playout"
                                            key={item?.id}
                                            draggable
                                            onDragStart={() => handleDragStart(index)}
                                            onDragEnter={() => handleDragEnter(index)}
                                            onDragEnd={handleDragEnd}
                                            onDragOver={(e) => e.preventDefault()}
                                            style={{ cursor: 'grab' }}
                                        >
                                            <Link id={`program-${index}`} to={`/edit/tv-playouts/${item?.id}`}>
                                                {renderTitleWithStatus(item)}
                                                <MessageSubHeading text={formatDate(item?.updated_at)} />
                                                {renderStreamSummary(item)}
                                            </Link>
                                            <FormContainer className={`justify-content-end pt-4`}>
                                                {<span id="status_btn" name="status" onClick={() => handleStatusToggle(index, item?.id, item?.status)}>{item?.status == 1 ? 'Disable' : 'Enable'}</span>}
                                                {<span id="destroy_btn" onClick={() => handleDelete(index, item?.id)}><FaTrashAlt /></span>}
                                            </FormContainer>
                                        </div>
                                    ))}
                                </FormContainer>
                            ) : (
                                <>
                                    {getSortedData().map((item, index) => (
                                        <div
                                            className="individual_playout_list"
                                            key={item?.id}
                                            draggable
                                            onDragStart={() => handleDragStart(index)}
                                            onDragEnter={() => handleDragEnter(index)}
                                            onDragEnd={handleDragEnd}
                                            onDragOver={(e) => e.preventDefault()}
                                            style={{ cursor: 'grab' }}
                                        >
                                            <FormContainer className={`align-items-center custom-border-bottom p-3`}>
                                                <LeftWrapper custom={true} className={`col-12 col-md-8 px-2 ps-md-0`}>
                                                    <Link id={`program-${index}`} to={`/edit/tv-playouts/${item?.id}`}>
                                                        <FormContainer>
                                                            <span className="playout-order-badge me-2">{index + 1}</span>
                                                            <img src={item?.image} className="individual_playout_list_img" />
                                                            <div className="ms-2">
                                                                <MessageHeading noMargin customPadding={`pb-0`} border text={item?.name} />
                                                                <MessageSubHeading text={formatDate(item?.updated_at)} />
                                                            </div>
                                                        </FormContainer>
                                                    </Link>
                                                </LeftWrapper>
                                                <RightWrapper custom={true} className={`col-12 col-md-4 px-2 pe-md-0 text-end`}>
                                                    <FormContainer className={`justify-content-end`}>
                                                        {<span id="status_btn" name="status" onClick={() => handleStatusToggle(index, item?.id, item?.status)}>{item?.status == 1 ? 'Disable' : 'Enable'}</span>}
                                                        {<span id="destroy_btn" onClick={() => handleDelete(index, item?.id)}><FaTrashAlt /></span>}
                                                    </FormContainer>
                                                </RightWrapper>
                                            </FormContainer>
                                        </div>
                                    ))}
                                </>
                            )
                        }
                    </Wrapper>
                )}
        </>
    );
}

export default Tvplayouts;
